import ModifyResBannerContainer from './ModifyResBannerContainer';

export default ModifyResBannerContainer;
